export * from 'fp-ts/Alt';
export function altAllBy(F) {
    return (startWith) => (...fs) => (a) => fs.reduce((mb, f) => F.alt(mb, () => f(a)), startWith);
}
//# sourceMappingURL=alt.js.map